<template>
  <div
    v-if="price"
    class="flex flex-wrap items-baseline gap-x-1.5"
    data-test-id="product-card-price"
  >
    <span
      class="font-bold"
      :class="[
        price.isSale ? 'text-red-600' : 'text-teal-900',
        AMOUNT_CLASSES[size],
      ]"
    >
      {{ price.amount }}
    </span>
    <span
      v-if="price.oldAmount"
      class="text-stone-500 line-through"
      :class="OLD_CLASSES[size]"
    >
      {{ price.oldAmount }}
    </span>
    <span v-if="price.unit" class="text-stone-500" :class="UNIT_CLASSES[size]">
      {{ price.unit }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type {
  ProductCardPartSize,
  ProductCardPrice,
} from '~/utils/productCardMapper'

const { price, size = 'default' } = defineProps<{
  price: ProductCardPrice | null
  size?: ProductCardPartSize
}>()

const AMOUNT_CLASSES: Record<ProductCardPartSize, string> = {
  default: 'text-body-xl',
  small: 'text-body',
  // md:font-bold: the text-body-xl token resets the weight to 400
  responsive: 'text-body md:text-body-xl md:font-bold',
}

const OLD_CLASSES: Record<ProductCardPartSize, string> = {
  default: 'text-caption-large',
  small: 'text-caption',
  responsive: 'text-caption md:text-caption-large',
}

const UNIT_CLASSES: Record<ProductCardPartSize, string> = {
  default: 'text-caption',
  small: 'text-caption-small',
  responsive: 'text-caption-small md:text-caption',
}
</script>
